export class ComboEmpresa {
	
	id:number;                 
 	codigo:string;           
 	nomeRazaoSocial:string;  
 	nomeFantasia:string;     
 	cnpj:string;             
}